<template>
    <auto-row class="wrap" mode="column">
        <auto-col>
            <head-nav @change="navChange"></head-nav>
        </auto-col>
        <auto-col class="page-top">
            <div class="banner-box" ref="eLocation">
                <img src="@/assets/image/product/04/00 banner.png" class="max-size" data-fit-cover alt=""  />
            </div>
        </auto-col>
        <auto-col style="background-color:#fff; border-bottom:1px solid #C7C7C7;">
            <location class="content-w" :data="currentNav.pathArr || []"></location>
        </auto-col>
        <auto-col  class="page-content" size="auto">
            <div class="f-a-j-j page-content-child">
                <div class="content-w">
                    <div class="page-content-box">
                        <div class="f-a-j-j-content">
                            <div class="title">
                                <span>设计</span>
                                <span>原则</span>
                            </div>
                            <p class="text">数据转化真实准确；信息传达明确，清晰的表达重要信息；有条理性的表达内容，使用户在短时间内获取更多信息；根据产品的需求，使用不同的元素进行设计。由产品经理、专业设计师等精心预设项目情况总览，政府工作指数，地理位置信息，智慧实时监控等多种模板，通过人性化的图表设计呈现，展示大数据成果，直观感受数据价值。</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="page-content-child"
                v-for="(src,i) of imgArr"
                :key="i"
            >
                <div class="content-w">
                    <img :src="src" width="100%" alt="" />
                </div>
            </div>
        </auto-col>
        <auto-col>
            <form-box></form-box>
            <footer-box></footer-box>
            <fixed-box></fixed-box>
        </auto-col>
    </auto-row>
</template>

<script>
    import {
        autoRow,
        autoCol
    } from "@/components"
    import headNav from "@/components/headNav"
    import formBox from "@/components/formBox"
    import footerBox from "@/components/footerBox"
    import fixedBox from "@/components/fixedBox"
    import location from "@/components/location"
    import {
        methods
    } from "@/mixins"
    export default {
        name: '',
        components: {
            autoRow,
            autoCol,
            headNav,
            formBox,
            footerBox,
            fixedBox,
            location,
        },
        mixins:[methods],
        props: [],
        data() {
            return {
                currentNav:{},
                imgArr:[
                    // require('@/assets/image/product/04/pic-1.png'),
                    require('@/assets/image/product/04/pic-2.png'),
                    require('@/assets/image/product/04/pic-3.png'),
                    require('@/assets/image/product/04/pic-4.png'),
                ]
                // type: this.$route.params.pathMatch.replace("/",''),
            }
        },
        computed: { //计算属性

        },
        watch: {  //监听器

        },
        methods: {
            navChange(nav){
                this.currentNav = nav;
            }
        },
        created(){

        }, //组件实例创建完成，属性已绑定，但DOM还未生成，属性还不存在
        mounted(){
            this.$refs.eLocation && this.toScrollTop(this.$refs.eLocation.offsetTop);
        }, //模板编译/挂载之后(不保证组件已在document中)
        beforeRouteLeave(to, from, next) {
            next();
        },
//        beforeCreate(){}, //组件实例刚被创建，组件属性计算之前，如data属性等
//        beforeMount(){}, //模板编译/挂载之前
//        beforeUpdate(){}, //组件更新之前
//        updated(){}, //组件更新之后
//        activated(){}, //for keep-alive,组件被激活时调用
//        deactivated(){}, //for keep-alive,组件被激活时调用
//        beforeDestory(){}, //组件销毁前调用
//        destoryed(){}, //组件销毁后调用
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .wrap{
        background-color:#f0f2f5;
        min-height:100vh;
    }
    .banner-box{
        position:relative;
    }
    .banner-box img{
        width:100%;
        max-height:600px;
        min-height:200px;
        overflow:hidden;
        vertical-align: middle;
    }

    .page-content{
        padding-bottom:100px;
        position: relative;
        z-index:2;
    }
    .page-content-child:nth-child(2n+1){
        background-color:#ffffff;
    }
    .page-content-child:nth-child(2n+2){
        background-color: #082334;
    }

    .page-content-child .title span:nth-child(1){
        color:#333333;
        font-size: 36px;
        line-height: 1;
        letter-spacing: 16px;
    }
    .page-content-child .title span:nth-child(2){
        color:#2FA8D0;
        font-size: 36px;
        line-height: 1;
        letter-spacing: 16px;
    }

    .page-content-box{
        overflow:hidden;
        min-height:500px;
    }

    .f-a-j-j .f-a-j-j-content{
        text-align: center;
        padding:200px 0 200px 0;
    }

    .f-a-j-j .text{
        color:#333333;
        font-size: 24px;
        padding:90px 140px 0 140px;
        line-height: 1.6;
        transition: all .3s;
    }

    .f-a-j-j .text:hover{
        transform: translateY(-5px);
    }

    /*适配不同尺寸*/
    @media screen and (max-width: 1540px){


    }

    @media screen and (max-width: 1200px){
        .f-a-j-j .f-a-j-j-content{
            text-align: center;
            padding:130px 0 180px 0;
        }
        .f-a-j-j .text{
            padding:95px 120px 0 120px;
        }

    }

    @media screen and (max-width: 960px){
        .f-a-j-j .f-a-j-j-content{
            text-align: center;
            padding:110px 0 160px 0;
        }
        .f-a-j-j .text{
            padding:75px 40px 0 40px;
        }

    }

    @media screen and (max-width: 760px){
        .f-a-j-j .f-a-j-j-content{
            text-align: center;
            padding:60px 0 80px 0;
        }
        .f-a-j-j .text{
            padding:55px 10px 0 10px!important;
        }
    }
</style>
